import { Component } from '@angular/core';
import { CancellationReasonsEditComponent } from '../../../../components/admin-dashboard-component/cancellation-reasons-component/cancellation-reasons-edit-component/cancellation-reasons-edit-component';

@Component({
  selector: 'app-cancellation-reasons-edit',
  imports: [CancellationReasonsEditComponent],
  templateUrl: './cancellation-reasons-edit.html',
  styleUrl: './cancellation-reasons-edit.scss',
})
export class CancellationReasonsEdit {}
